<div class="modal-header">
    <h3 class="modal-title">{{ 'SAMENWERKEN.TITEL' | translate }}</h3>
</div>

@if (laden) {
    <div class="dl-samenwerkdialoog__laden">{{ 'LOADING' | translate }}</div>
}

<div class="modal-body">
    @if (meekijker) {
        <p>{{ 'SAMENWERKEN.MEEKIJKER' | translate:{meekijker: meekijker} }}</p>
    }

    @if (samenwerking.meekijkmodel()) {
        <p>{{ 'SAMENWERKEN.KIJKMEEBIJ' | translate:{primaryuser: primaryNaam} }}</p>
    }

    @if (rol === 'single') {
        <h3 class="dl-samenwerkdialoog__subtitel dl-samenwerkdialoog__rij">
            {{ 'SAMENWERKEN.WORDPRIMARY' | translate }}</h3>
        <p class="dl-samenwerkdialoog__rij">{{ 'SAMENWERKEN.WORDPRIMARYINTRO' | translate }}</p>
        <div class="dl-samenwerkdialoog__rij">
            <button class="btn btn-primary" (click)="maakPrimary()">
                {{ 'SAMENWERKEN.STARTPRIMARY' | translate }}
            </button>
        </div>

        <h3 class="dl-samenwerkdialoog__subtitel dl-samenwerkdialoog__rij">
            {{ 'SAMENWERKEN.WORDSUB' | translate }}</h3>
        <p class="dl-samenwerkdialoog__rij">{{ 'SAMENWERKEN.WORDSUBINTRO' | translate }}</p>
        <div class="dl-samenwerkdialoog__rij">
            <input type="text" maxlength="3" size="3" [(ngModel)]="subcode[0]">
            -
            <input type="text" maxlength="3" size="3" [(ngModel)]="subcode[1]">
            -
            <input type="text" maxlength="3" size="3" [(ngModel)]="subcode[2]">
        </div>
        <div class="dl-samenwerkdialoog__rij">
            <button class="btn btn-primary" (click)="maakSub()">
                {{ 'SAMENWERKEN.STARTSUB' | translate }}
            </button>
        </div>
    }

    @if (rol === 'primary') {
        <h3 class="dl-samenwerkdialoog__subtitel dl-samenwerkdialoog__rij">
            {{ 'SAMENWERKEN.PRIMARY' | translate }}</h3>
        <p class="dl-samenwerkdialoog__rij">{{ 'SAMENWERKEN.PRIMARYINTRO' | translate }}</p>
        <p class="dl-samenwerkdialoog__rij">
            <span>{{ 'SAMENWERKEN.PRIMARYCODE' | translate }}</span>: <b>{{ stand?.primarycode }}</b>
        </p>
    }

    @if (rol === 'sub' && !samenwerking.meekijkmodel()) {
        <p>{{ 'SAMENWERKEN.SUBONDERPRIMARY' | translate:{primaryuser: primaryNaam} }}</p>
    }

    @if (toonDeelnemers) {
        <h3 class="dl-samenwerkdialoog__subtitel dl-samenwerkdialoog__rij">
            {{ 'SAMENWERKEN.GEDEELD_MET' | translate }}</h3>
        <p class="dl-samenwerkdialoog__rij">{{ primaryNaam }}@for (deelnemer of stand?.subs; track $index) {, {{ deelnemer.user }}}</p>
        <div class="dl-samenwerkdialoog__rij">
            <button class="btn btn-primary" (click)="ontkoppel()">
                {{ 'SAMENWERKEN.ONTKOPPELEN' | translate }}
            </button>
        </div>
    }

    @if (fout) {
        <div class="dl-samenwerkdialoog__fout">{{ fout | translate }}</div>
    }
</div>

<div class="modal-footer">
    <button class="btn btn-secondary" (click)="sluit()">{{ 'BTN_CLOSE' | translate }}</button>
</div>
